/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Auth = React.createContext();

export function useAuth (){
    return useContext(Auth);
}

function AuthProvider({children}){

    const [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [profile, setProfile] = useState({
        isLogged : !!localStorage.getItem('user'),
        email : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).email : null,
        user_id : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).user_id : null,
        group_id : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).group_id : null,
        fname : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).fname : null,
        lname : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).lname : null,
        phone : localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).phone : null,
        userToken: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).userToken : null,
    });
    // group_id :2 -> admin
    // group_id :3 -> merchant
    // group_id :4 -> user

    function logIn (user) {
        localStorage.setItem('user', JSON.stringify(user));
        setProfile({isLogged: true,  ...user});
    }

    function logOut (){
        localStorage.removeItem('user');
        setProfile( prevState =>({isLogged: false}) );
    }

    function linkToDashBoard(){
        const _token = profile.userToken;
        if( typeof _token != "undefined"){
            if(profile.group_id == 2 || profile.group_id == 3){
                window.location = `${process.env.REACT_APP_URL}${i18n.language}/action-login-user?usertoken=${_token}`;
            }else{
                navigate(`/${i18n.language}/dashboard`);
            }

        }
    }

    // useEffect( ()=>{
    //     const _user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    //     if(_user){
    //         logIn(_user);
    //     }
    // },[] );

    useEffect( ()=>{
        if( typeof searchParams.get("logout") != "undefined" && searchParams.get("logout") ==1 ){
            logOut();
        }
    },[] );

    return(
        <Auth.Provider value = { {profile, logIn, logOut, linkToDashBoard} }>
            {children}
        </Auth.Provider>
    )

}

export default AuthProvider;